// exportEntriesToExcel.js
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Pomocniczo konwersja timestamp/Date na czytelny string
function formatDate(val) {
  if (!val) return "";
  if (val?.toDate) return val.toDate().toISOString().slice(0, 19).replace("T", " ");
  if (val instanceof Date) return val.toISOString().slice(0, 19).replace("T", " ");
  return val;
}

function formatEntryForExport(entry) {
  const flatData = { ...entry };

  for (const key in flatData) {
    flatData[key] = formatDate(flatData[key]);
  }

  return flatData;
}

export function exportEntriesToExcel(entries = []) {
  const formattedEntries = entries.map(formatEntryForExport);

  const ws = XLSX.utils.json_to_sheet(formattedEntries);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Wpisy AI Journal");

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([wbout], { type: "application/octet-stream" }),
    "wpisy-ai-journal.xlsx"
  );
}